import { render, staticRenderFns } from "./StartupList.vue?vue&type=template&id=5366db65&scoped=true"
import script from "./StartupList.vue?vue&type=script&lang=js"
export * from "./StartupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366db65",
  null
  
)

export default component.exports